<template>
  <div class="community-item" @click="toArticleDetail">
    <div class="action_message" v-if="action">
      <!--        我的互动页面显示互动详细操作-->
      <div class="opration"
           v-show="action && (communityData.my_status.has_liked || communityData.my_status.has_commented||communityData.my_status.has_voted)">
        <span v-if="communityData.my_status.has_commented||communityData.my_status.has_liked">
        你<span>{{communityData.my_status.has_liked?'点赞':''}}</span>
        <span v-if="communityData.my_status.has_liked && communityData.my_status.has_commented">、</span>
        <span>{{communityData.my_status.has_commented?'评论':''}}</span>了此帖子</span>
        <span v-if="communityData.my_status.has_voted">{{(communityData.my_status.has_commented||communityData.my_status.has_liked)?',你参与了社区投票':'你参与了社区投票'}}</span>
      </div>
      <!--      我的互动页面显示互动详细时间-->
      <div class="action_time" v-show="action">
        {{communityData.operation_at | articleTimeFormatFilter}}
      </div>
    </div>
    <div class="community-item-header flex-between" style="flex-wrap: wrap">
      <div class="user-info flex-start" v-if="communityData.user">
        <div class="user-avatar">
          <img :src="communityData.user.avatar_url" alt="">
        </div>
        <span class="user_name"
              :class="{'list_user_name': dataType==='list' && communityData.user.username.length > 15}">{{communityData.user.username || '超级简历用户'}}</span>
        <img src="https://files.wondercv.com/rn/bbs/hotnew.png" alt=""
             v-show="communityData.tag_ids && communityData.tag_ids[0]===0 && dataType === 'list'"
             style="margin-left: 10px">
        <official :is_rb="communityData.user.is_rb" :adminId="communityData.admin_id" style="margin-left: 10px"/>
      </div>
      <div class="post-type"
           v-show="top[communityData.priority] && !action && !collection && !news && dataType === 'list'">
        <span>置顶</span>
        <span class="iconfont iconzhiding"></span>
      </div>
    </div>
    <template v-if="communityData.user&&communityData.user.community_identity">
      <div class="identity">
        {{communityData.user.community_identity}}
      </div>
    </template>

    <template v-if="communityData.page">
      <div class="community-item-page flex-between" v-if="communityData.page.token" @click.stop="toBlogDetail">
        <div class="page-info flex-column">
          <span class="page-title" v-html="highLight(communityData.page.name)"></span>
          <span class="page-desc" v-html="highLight(communityData.page.description)"></span>
        </div>
        <img :src="communityData.page.img" alt="">
      </div>
    </template>

    <div class="community-item-content" :class="{'list-item-content': dataType === 'list'}">

      <h1 class="community-item-title" :class="{'detail-title-con': dataType === 'detail'}"
          v-html="highLight(communityData.title)"></h1>
      <div class="job-card" @click.stop="toJobDetail(jobDetail)" v-if="jobDetail">
        <div class="job-header">
          <p class="job-post">{{jobDetail.job_post}}</p>
          <p class="job-salary">{{(jobDetail.annual_month_salary && jobDetail.annual_month_salary > 12) ? `${jobDetail.salary} · ${jobDetail.annual_month_salary}薪` : `${jobDetail.salary}`}}</p>
        </div>
        <div class="company">
          <img :src="jobDetail.company_logo" alt="">
          <span style="max-width: 110px">{{jobDetail.company_name}}</span>
          <span style="max-width: 60px">{{jobDetail.degree_name || '不限'}}</span>
          <span style="max-width: 60px">{{jobDetail.experience | experienceFilter }}</span>
          <div>
            {{jobDetail.city_names || '全国'}}
          </div>
        </div>
      </div>
      <div ref="communityContent" class="community-item-desc"
           :class="[{'detail-line-height': dataType === 'detail'}]"
           v-html="highLight(communityData.content,communityData.vote)">
      </div>
      <div v-if="dataType === 'list'" class="more-item"
           style="line-height: 24px;font-size: 16px;color: #737F9F">...全文
      </div>

      <div class="community-item-images flex-start" v-if="communityData&&communityData.images">
        <template v-if="communityData.images.length>0 && communityData.images.length!=1 && communityData.images.length!=4">
          <template v-for="(item, i) in communityData.images">
            <img :src="item" alt="" :key="i" @click.stop="showBigImg({index:i,list:communityData.images})">
            <!--            <img :src="item + '?x-oss-process=image/resize,w_300'" alt="" :key="index" v-else>-->
          </template>
        </template>
        <template v-else-if="communityData.images.length == 4">
          <template v-for="(item, i) in communityData.images">
            <img :src="item" alt="" :key="i" @click.stop="showBigImg({index:i,list:communityData.images})" :style="{marginRight: ( i === 1 ? '104px' : 0 ), marginLeft: ((i === 2 || i === 0) ? 0 :'6px') }">
          </template>
        </template>
        <template v-else-if="communityData.images.length == 1">
          <img :src="communityData.images[0]" alt="" @click.stop="showBigImg({index:0,list:communityData.images})"
               :style="{width:oneImage.w+'px',height:oneImage.h+'px',minWidth:oneImage.w+'px',minHeight:oneImage.h+'px'}">
        </template>
      </div>

      <vote v-if="communityData.vote" :data="communityData.vote" :scenario="dataType" @on-vote="handleClickVote"
            :to-detail="()=>toArticleDetail()"/>

      <div class="community-update-time-wrapper flex-between" v-if="dataType === 'detail'">
        <span class="community-update-time">{{ communityData.publish_at | articleTimeFormatFilter }}</span>
        <div v-if="communityData.allow_delete" class="flex-start" @click="deleteArticle">
          <span class="iconfont icontrash-"/>
          <span>删除</span>
        </div>
      </div>
      <div class="flex-start topic" v-if="dataType === 'list' && communityData.topic && communityData.topic.id"
           @click.stop="toTopicDetail">
        <img src="https://files.wondercv.com/rn/bbs/topcimini.png" width="14" height="14" alt=""
             style="margin-right: 5px">
        <span class="community-item-text">{{ communityData.topic.name }}</span>
      </div>
      <div class="flex-between community-detail-topic"
           v-else-if="dataType === 'detail' && communityData.topic && communityData.topic.id"
           @click.stop="toTopicDetail">
        <div class="flex-start">
          <img :src="communityData.topic.cover_image" alt="">
          <div class="topic-info flex-column">
            <span class="title">{{ communityData.topic.name }}</span>
            <span class="community-num">{{ communityData.topic.interactive_count }}人正在讨论</span>
          </div>
        </div>
        <div class="topic-detail flex-center">去看看</div>
      </div>
    </div>

    <div v-if="dataType === 'list'&&communityData.hot_comments && communityData.hot_comments.length > 0"
         class="hot-comment">
      <div>
        <img src="https://files.wondercv.com/rn/bbs/commentHot.png" class="hot-comment-image">
      </div>
      <div>
        <p v-for="item in communityData.hot_comments" :key="item.id" class="hot-comment-item">
          <span>{{item.user.username}}：</span><span class="hot-comment-item-content " v-html="highLight(item.content)"></span>
        </p>
      </div>
    </div>

    <div class="community-item-footer flex-between" v-if="dataType === 'list'">
      <div class="operation-item enjoy flex-start" @click.stop="toArticleDetail('share')">
        <span class="iconfont iconfenxiang1"></span>
        <span class="enjoy-total">分享</span>
      </div>
      <div class="operation-content flex-start" v-if="communityData.my_status">
        <div class="operation-item comment flex-start collect-expand" @click.stop="collectArticle">
          <span class="iconfont" :class="communityData.my_status.has_collected ? 'iconyishoucang1' : 'iconweishoucang' "></span>
          <span class="comment-total">{{ communityData.my_status.has_collected ? '已收藏' : '收藏' }}</span>
        </div>
        <div class="operation-item comment flex-start" @click.stop="toArticleDetail('comment')">
          <span class="iconfont iconpinglun1"></span>
          <span class="comment-total">{{ communityData.comment_count | countFilter('comment')}}</span>
        </div>
        <div class="operation-item approve flex-start" v-if="communityData.topic.id!=81" style="margin-right: -10px"
             @click.stop="likeArticle">
          <transition name="like">
            <span v-if="communityData.my_status.has_liked&&communityData.topic.id!=81"
                  class="iconfont icondianzan1 anim-icon"></span>
          </transition>
          <transition name="not">
            <span v-if="!communityData.my_status.has_liked&&communityData.topic.id!=81"
                  class="iconfont iconweidianzan1 anim-icon"></span>
          </transition>
          <span class="approve-total"
                style="margin-left: 30px">{{ communityData.like_count | countFilter('like') }}</span>
        </div>
        <animation-exp v-else type="list" :num="communityData.like_count" :has_like="communityData.my_status.has_liked"
                       @click.native.stop="likeArticle"/>
      </div>
    </div>
    <w-share-wx :state="shareWxState" @handleClose="shareWxState = false"/>
  </div>
</template>

<script>
  import WShareWx from '../../../components/global/w-share-wx'
  import Vote from "./vote"
  import AnimationExp from "./animationExp"
  import {componentsMixin} from '../../../assets/js/mixin/components'
  import {mapMutations, mapState} from 'vuex'
  import {communityMixin} from '../../../assets/js/mixin/community'
  // import BigImgPopup from '../../community/components/big-img-popup'
  // import BigImg from './big-img'
  import {envMixin, loginMixin} from '../../../assets/js/mixin/global'
  import Cookies from 'js-cookie'
  import official from "./official"
  import {formatImageWidthHeight, UrlParamHash} from "../../../assets/js/utils";
  import qs from "querystring"
  import api from "../../../api/api-list/index"
  import HrApi from "../../../api/api-list/hr";
  export default {
    name: 'community-item',
    mixins: [componentsMixin, communityMixin, envMixin, loginMixin],
    props: {
      communityData: {
        type: Object,
        default: () => {
          return {}
        }
      },
      dataType: {
        type: String,
        default: 'list'
      },
      // 是否搜索列表
      search: {
        type: Boolean,
        default: false
      },
      // 搜索的高亮文字
      searchText: {
        type: String,
        default: ''
      },
      // 是否互动列表
      action: {
        type: Boolean,
        default: false
      },
      // 是否收藏列表
      collection: {
        type: Boolean,
        default: false
      },
      // 是否我的发布列表
      news: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        commentShow: false,
        shareWxState: false,
        bigImgState: false,
        imgIndex: 0,
        top: {
          2: '话题置顶',
          5: '评论置顶',
          8: '话题和评论置顶'
        },
        contentComponent: '',
        oneImage: {
          w: 196,
          h: 110
        },
        isShowMore: false,
        jobDetail: null
      }
    },
    created() {
      if (this.communityData.images && this.communityData.images.length == 1) {
        let params = null
        try {
          params = UrlParamHash( this.communityData.images[0] )
        }catch (e) {

        }
        if(!!params && !!params.width && !!params.height){
          this.oneImage.w = Number(params.width)
          this.oneImage.h = Number(params.height)
        }else{
          let src = this.communityData.images[0]
          let img = new Image();
          img.src = src
          img.onload = () => {
            this.oneImage = formatImageWidthHeight(img.width, img.height)
          }
        }

      }
    },
    mounted() {
      if (this.dataType === 'list') {
        this.caleHeight()
        this.listenLinkClick()
      }
      if(this.communityData.job_token){
        this.getRecommendJobDetail(this.communityData.job_token)
      }
    },
    computed: {
      ...mapState('community', ['newList']),
      linkContent() {
        // const re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-\.\/\?%&=]*)?)/gi
        const re = /((http[s]{0,1}|ftp):\/\/[a-zA-Z0-9\.\-]+\.([a-zA-Z]{2,4})(:\d+)?(\/[a-zA-Z0-9\.\-~!@#$%^&*+?:_/=<>[\u4e00-\u9fa5]*]*)+)|(www.[a-zA-Z0-9\.\-]+\.([a-zA-Z]{2,4})(:\d+)?(\/[a-zA-Z0-9\.\-~!@#$%^&*+?:_/=<>[\u4e00-\u9fa5]*]*)+)/gi
        if (this.communityData.content) {
          return this.communityData.content.replace(re, a => `<a href="${a}">网页链接</a>`)
        }
      }
    },
    watch: {
      communityData(val) {
        if (this.dataType === 'detail') {
          this.listenLinkClick()
        }
        // this.createChildComponent()
        if (val != null && val != undefined) {
          if (this.communityData.images && this.communityData.images.length == 1) {
            let src = this.communityData.images[0]
            let img = new Image();
            img.src = src
            img.onload = () => {
              this.oneImage = formatImageWidthHeight(img.width, img.height)
            }
            img.onload()
          }
        }
      },
      index() {
        this.caleHeight()
      }
    },
    components: {
      WShareWx,
      Vote,
      AnimationExp,
      official
    },
    methods: {
      ...mapMutations('community', ['setRecommendData']),
      // 监听页面的点击事件
      listenLinkClick() {
        this.$refs['communityContent'].addEventListener('click', (event) => {
          event.preventDefault()
          if (this.dataType === 'detail') {
            let {href} = event.target
            const reg = /.*(\.wondercv\.(cn|com)).*/gim
            if (href.includes('wondercv') && href.includes('/community/article/')) {
              let id = href.match('[^/]+(?!.*/)')[0]
              let {token} = this.$route.params
              if (this.isWxMini && token !== id) {
                this.$db.ls.set('shareNeed', true)
                let title = this.getUrlParam('title', href.match(/\?.*/) && href.match(/\?.*/)[0])
                let url = `/pages/news-detail/news-detail?url=${process.env.VUE_APP_HOST}/community/article/${id}`
                if (title) url = `/pages/news-detail/news-detail?url=${process.env.VUE_APP_HOST}/community/article/${id}&title=${title}`
                this.$wechat.miniProgram.navigateTo({url})
              } else if (token !== id) {
                this.$db.ls.set('shareNeed', true)
                this.$router.push(`/community/article/${id}`)
              }
            } else if (reg.test(href) || !this.isWxMini) {
              window.location.href = href
            } else {
              this.$wechat.miniProgram.navigateTo({url: `/pages/out-link/out-link?url=${href}`})
            }
          }
        })
      },
      // 高亮过滤
      highLight(content, vote) {
        if (content) {
          if (this.dataType == 'list') {
            content = content.trimStart()
            content = content.split("")
            content.reduce((before, now, currentIndex) => {
              if (before.charCodeAt() == 10 && now.charCodeAt() == 10) {
                content[currentIndex] = ""
                return now
              }
              return now
            })
            content = content.join("")
          }
          let arr = []
          // const re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-\.\/\?%&=]*)?)/gi
          // const re =/^https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+)/gi
          // const re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[a-zA-Z0-9\.\-~!@#$%^&*+?:_/=<>[\u4e00-\u9fa5]*]*)+)|(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-\.\/\?%&=]*)?)/gi
          // const re = /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/gi
          const re = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#]))/gi
          content = content.replace(re, a => `<span class="iconfont iconlink"></span><a href="${a}">网页链接</a>`)
          let con = content.split('\n').forEach(item => arr.push(`${item.trim()}`))
          if (this.search) {
            let reg = `/${this.searchText}/g`
            return `<span style="color: #ff6644;font-weight: 500">${!!vote?'【投票】':''}</span>` + arr.join('<br>').replace(eval(reg), `<span class="con_high_light" style="color: #ff6644">${this.searchText}</span>`)
          } else {
            return `<span style="color: #ff6644;font-weight: 500">${!!vote?'【投票】':''}</span>` + arr.join('<br>')
          }
        }
      },
      // 显示大图
      showBigImg(data) {
        console.log(data)
        // this.bigImgState = true
        // this.imgIndex = index
        this.$emit('showBigImg', data)
      },

      // 跳转攻略详情
      toBlogDetail() {
        let {page: {token, name}} = this.communityData
        this.$db.ls.set('shareNeed', true)
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/blog-detail/blog-detail?url=${process.env.VUE_APP_HOST}/community/blog/${token}&title=${name}`
          })
        } else {
          this.$router.push(`/community/blog/${token}`)
        }
      },
      // 删除文章
      async deleteArticle() {
        let {id} = this.communityData
        this.$createDialog({
          type: 'confirm',
          title: '提示',
          content: `是否删除当前讨论帖`,
          confirmBtn: {
            active: false,
            text: '取消'
          },
          cancelBtn: {
            active: true,
            text: '删除'
          },
          onCancel: async () => {
            let res = await this.$api.bbs.deleteArticle(id)
            if (res.code === 1000) {
              this.showToast('删除成功', 1500)
              const list = this.newList.filter(item => item.id !== id)
              this.setRecommendData({list})
              setTimeout(() => {
                this.isWxMini ? this.$wechat.miniProgram.navigateBack() : this.$router.back()
              }, 1500)
            }
          }
        }).show()
      },
      // 跳转文章详情
      toArticleDetail(type) {
        let {id, title, content} = this.communityData
        let {name} = this.$route
        console.log(name)
        if (name === 'article-detail') {
          type === 'share' ? this.shareArticle() :
            type === 'comment' ? this.$emit('handleComment', 'create', this.communityData) :
              ''
        } else {
          this.$db.ls.set('shareNeed', true)
          if (this.isWxMini) {
            this.$wechat.miniProgram.navigateTo({
              url: `/pages/news-detail/news-detail?url=${process.env.VUE_APP_HOST}/community/article/${id}&title=${title || content}`
            })
          } else {
            this.$router.push(`/community/article/${id}?name=${name}`)
          }
        }
      },
      // 跳转话题聚合页
      toTopicDetail() {
        this.$db.ls.set('shareNeed', true)
        let {topic: {id, name, image}} = this.communityData
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/news-group/news-group?url=${process.env.VUE_APP_HOST}/community/topic/${id}&title=${name}&image=${image}`
          })
        } else {
          this.$router.push(`/community/topic/${id}`)
        }
      },
      // 获取url中的某个参数
      getUrlParam(key, params) {
        const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
        let result = params ? params.substr(1).match(reg)[2] : null
        if (result && result[2]) {
          return result[2]
        }
      },
      handleClickVote(select) {
        this.communityData.vote.my_choices = select
        this.communityData.vote.participant_count++
        this.communityData.vote.options = this.communityData.vote.options.map(item => {
          if (select.includes(item.id)) {
            item.choose_count++
          }
          return item
        })
      },
      caleHeight() {
        let el = this.$refs['communityContent']
        if (Number(getComputedStyle(el).height.replace("px", "")) >= 96) {
          this.isShowMore = true
        } else {
          this.isShowMore = false
        }
      },
      toJobDetail(item){
        if (this.iosOrAndroid) {
          window.location.href = `/jobs/${ item.token }.html`
        } else if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/jobDetail/jobDetail?url=${ process.env.VUE_APP_HOST }/jobs/recommend/${ item.token }&companyToken=${ item.company_token }&com_name=${ item.company_name }&info_name=${ item.job_post }&in=job_xcx`
          })
        } else if (this.isWxMini) {
          let url = `/pages/job-detail/job-detail?url=${ process.env.VUE_APP_HOST }/jobs/recommend/${ item.token }&companyToken=${ item.company_token }&com_name=${ item.company_name }&info_name=${ item.job_post }`
          this.$db.ls.set('shareNeed', true)
          this.$wechat.miniProgram.navigateTo({ url })
        } else {
          this.$router.push({
            path: `/jobs/recommend/${ item.token }`,
            query: {
              companyToken: item.company_token
            }
          })
        }
      },
      getRecommendJobDetail(token){
        this.$api.HrApi.getRecommendJobDetail(token).then(res=>{
          if(res.code === 1000){
            this.jobDetail = res.data.job
          }
        })
      }
    },
    filters:{
      experienceFilter: function (value) {
        if(value == '1年以下'){
          return '1年以内'
        }else {
          return  value
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  .job-card{
    padding: 16px 18px 14px 18px;
    background: #F9F9F9;
    border-radius: 6px;
    margin-bottom: 10px;
    .job-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .job-post{
        font-size: 16px;
        font-weight: 500;
        color: #404040;
        line-height: 16px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .job-salary{
        font-size: 16px;
        font-weight: 600;
        color: #FF6644;
        line-height: 16px;
        letter-spacing: 1px;
      }
    }
    .company{
      display: flex;
      align-items: center;
      img{
        width: 24px;
        height: 24px;
        border-radius: 2px;
        border: 1px solid #ECECEC;
      }
      div{
        flex: 1;
        text-align: right;
        font-size: 12px;
        color: #bcbcbc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span{
        padding: 0 6px;
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 14px;
        position: relative;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &::after{
          content: "";
          width: 1px;
          height: 9px;
          position: absolute;
          right: 0;
          top: 2px;
          background: #CFCFCF;
        }
        &:nth-of-type(3)::after{
          display: none;
        }
      }
    }
  }
  .community-content-clip {
    marginBottom: 0;
    overflow: hidden;
    height: 96px;
    text-overflow: clip;
  }

  .more-item {
    display: none;
    margin-top: -8px;
  }

  .more-item-show {
    display: block;
  }

  .con_high_light {
    color: #FF6644;
  }


  .community-item {
    padding: 16px 19px 18px;
    background-color: $color-light;
    margin-bottom: 8px;

    .identity {
      line-height: 12px;
      font-size: 12px;
      color: #9c9c9c;
      margin-bottom: 16px;
      padding: 0 5px;
    }

    .action_message {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #9c9c9c;
      margin-bottom: 12px;
      padding-left: 3px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .community-item-header {
      margin-bottom: 4px;
      padding: 0 5px;

      .user-info {
        width: auto;
        //max-width: 280px;
        //width: 85%;
        img {
          width: 40px;
          height: 16px;
          //margin-left: 10px;
        }

        .user-avatar {
          margin-right: 8px;
          flex-shrink: 1;

          img {
            width: 20px;
            height: 20px;
            //border-left: 0;
            border-radius: 50%;
          }
        }

        .user_name {
          color: $color-dark-gray;
          font-size: $font-size-small;
        }

        .list_user_name {
          //width: 70%;
          //overflow: hidden;
          //text-overflow: ellipsis;
          //white-space: nowrap;
        }

        .opration {
          margin-left: 8px;
          color: #9c9c9c !important;
          font-size: $font-size-small;
        }
      }

      .post-type {
        width: auto;
        height: 100%;
        display: flex;
        align-items: center;
        color: #FF6644;
        font-size: $font-size-small;

        span:first-child {
          margin-right: 3px;
        }
      }

      .action_time {
        font-size: $font-size-small;
        color: #9c9c9c;
      }
    }

    .community-item-page {
      margin: 2px 0 8px 0;
      padding: 16px 24px 16px 16px;
      background-color: #F9F9F9;
      border-radius: 6px;

      .page-info {
        flex-shrink: 1;

        .page-title {
          color: $color-title;
          font-weight: 600;
          margin-bottom: 12px;
        }

        .page-desc {
          font-size: $font-size-small;
          color: #9c9c9c;
        }
      }

      img {
        width: 36px;
        height: 36px;
        border-radius: 4px;
        /*margin-left: 10px;*/
        border: 1px solid #000;
      }
    }

    .community-item-content {
      padding: 0 5px;

      .community-item-title {
        font-size: $font-size-medium-x;
        color: $color-title;
        line-height: 22px;
        margin-bottom: 8px;
        font-weight: bold;
      }

      .detail-title-con {
        font-size: 18px;
      }

      .community-item-desc {
        color: $color-title;
        line-height: 24px;
        margin-bottom: 8px;
        word-break: break-all;
        letter-spacing: 0.4px;

        /deep/ * {
          user-select: auto;
          -moz-user-select: auto;
          -ms-user-select: auto;
          -webkit-user-select: auto;
        }

        /deep/ a {
          color: #3381FF;
        }

        /deep/ .iconlink {
          color: #3381FF;
          font-weight: 600;
        }
      }

      .detail-line-height {
        font-size: 16px;
        line-height: 30px;
      }

      /*.ellipsis-class {*/
      /*  overflow: hidden;*/
      /*  display: -webkit-box; //作为弹性伸缩盒子模型显示。*/
      /*  -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列*/
      /*  -webkit-line-clamp: 4 //显示的行*/
      /*}*/

      .community-item-images {
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-bottom: 8px;

        img {
          width: 104px;
          height: 104px;
          border-radius: 4px;
          object-fit: cover;
          margin-left: 4px;
          margin-bottom: 4px;
        }

        img:first-child, img:nth-child(4), img:nth-child(7) {
          margin-left: 0;
        }
      }

      .community-update-time-wrapper {
        margin-top: 16px;

        .community-update-time {
          color: #9C9C9C;
          font-size: $font-size-small;
        }

        span {
          font-size: 12px;
          color: #9c9c9c;
        }

        .iconfont {
          font-size: 16px;
          margin-right: 4px;
          font-weight: 500;
        }
      }

      .topic {
        /*width: 60px;*/
        width: fit-content;
        padding: 6px 8px;
        background-color: #f9f9f9;
        border-radius: 13px;
        box-sizing: border-box;
        line-height: 12px;

        .icon {
          width: 18px;
          height: 18px;
          background-color: #FF6644;
          border-radius: 12px;
          margin-right: 6px;
          color: $color-light;
        }

        .community-item-text {
          color: #404040;
          font-size: $font-size-small;
        }
      }

      .community-detail-topic {
        padding: 8px 16px;
        background-color: #FEFFFF;
        border: 1px solid #F4F4F4;
        border-radius: 4px;
        margin-top: 16px;

        img {
          width: 42px;
          height: 42px;
          border-radius: 4px;
          margin-right: 10px;
          object-fit: cover;
        }

        .topic-info {
          justify-content: space-between;

          .title {
            font-size: 16px;
            font-weight: 600;
            color: $color-dark-gray;
            margin-bottom: 10px;
          }

          .community-num {
            color: #9C9C9C;
            font-size: $font-size-small;
          }
        }

        .topic-detail {
          width: 60px;
          height: 26px;
          border-radius: 14px;
          background-color: #f4f4f4;
          color: #606060;
          font-size: $font-size-small;
        }
      }
    }

    .list-item-content {
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 24px;
    }

    .community-item-footer {
      height: 24px;
      align-items: center;
      //line-height: 24px;
      .operation-item {
        font-size: $font-size-small;
        position: relative;
        width: 64px;

        &:last-child {
          margin-right: 0;
        }

        .iconfont {
          font-size: 24px;
          //margin-right: 6px;
        }

        .iconyishoucang1 {
          color: rgb(255, 201, 47);
        }

        .icondianzan1 {
          color: rgb(255, 91, 67);
        }

        img {
          width: 16px;
          margin-right: 6px;
        }
      }
      .collect-expand {
        margin-right: 10px;
      }

      .enjoy, .like, .comment, .approve {
        color: $color-title;
      }

      .enjoy-total, .like-total, .comment-total, .approve-total {
        max-width: 29px;
        margin-left: 3px;
        white-space: nowrap;
        color: $color-title;
      }

      .like-total, .approve-total {
        min-width: 12px
      }
    }

    .hot-comment {
      width: 100%;
      padding: 12px;
      background: #F9F9F9;
      margin-bottom: 18px;
      border-radius: 6px;

      .hot-comment-image {
        width: 32px;
        height: 19px;
        margin-bottom: 8px;
      }

      .hot-comment-item {
        color: #404040;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0.4px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;

        .hot-comment-item-content {
          color: #9c9c9c;
        }
      }
    }
  }


  .anim-icon {
    position: absolute;
  }

  .like-enter, .like-leave-to {
    transform: scale(0);
  }

  .like-enter-active {
    transition: all 0.2s .2s;
  }

  .like-leave-active {
    transition: all .2s;
  }

  .not-enter, .not-leave-to {
    transform: scale(0);
  }

  .not-enter-active {
    transition: all .2s .2s;
  }

  .not-leave-active {
    transition: all .2s;
  }


</style>
